import { useState, useEffect } from "react";
import { Box, DialogActions, DialogContent } from "@mui/material";
import TextInputComponent from "../../../atom/Inputs/TextInput";
import TextButtonComponet from "../../../atom/Buttons/TextButton";
import { Actions } from "../../../../core/modules/Actions";
import { connect } from 'react-redux';
import { getText } from "../../../../core/Constant";
import { useDispatch } from 'react-redux';


const AdminCourseSectionEditForm = ({ onClose, isclose, courseSectionData }) => {
    const dispatch = useDispatch();
    const [content_id, setContentId] = useState(0);

    const [title, setTitle] = useState('');
    const [titleError, setTitleError] = useState(false);
    const [titleErrorMsg, setTitleErrorMsg] = useState('Please add the section name');
    const [titalValid, setTitleVaid] = useState(false);

    useEffect(() => {
        setTitleVaid(false);
        setTitleError(false);
        setTitleErrorMsg('Please add the section name');
    }, [onClose]);


    useEffect(() => {
        setTitleVaid(false);
        setTitleError(false);
        setTitleErrorMsg('Please add the section name');
    }, [isclose]);

    useEffect(() => {
        const secName = courseSectionData?.section_name || '';
        setTitle(secName);
        setContentId(courseSectionData?.section_id || 0);
        if (secName.length > 255) {
            setTitleError(true);
            setTitleErrorMsg("Maximum 255 characters allowed.");
            setTitleVaid(false);
        } else {
            setTitleError(false);
            setTitleErrorMsg("Please add the section name");
            setTitleVaid(secName.trim().length > 0);
        }
    }, [courseSectionData]);


    const onTitleChange = (e) => {
        const text = getText(e);
        setTitle(text);
        if (text && text.length > 255) {
            setTitleError(true);
            setTitleErrorMsg("Maximum 255 characters allowed.");
            setTitleVaid(false);
        } else {
            setTitleError(false);
            setTitleErrorMsg("Please add the section name");
            const isValid = text?.trim().length > 0;
            setTitleVaid(isValid);
        }
    };

    const updateCourseContent = () => { 
        if (titalValid) {
            dispatch(Actions.course.updateCourseSectionName({ content_id: content_id, week: title }));
            onClose();
        } else {
            setTitleError(true);
            if (title && title.length > 255) {
                setTitleErrorMsg("Maximum 255 characters allowed.");
            } else {
                setTitleErrorMsg("Please add the section name");
            }
        }
    };

    return (
        <>
            <form>
                <DialogContent>
                    <Box>
                        <Box>
                            <TextInputComponent
                                label={"Section Name"}
                                isError={titleError}
                                placeholder="Enter section name"
                                name={"title"}
                                value={title}
                                error={titleErrorMsg}
                                onchange={onTitleChange}
                            />
                        </Box>

                    </Box>
                </DialogContent>
                <DialogActions sx={{ mr: 2, mb: 2 }}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                        <TextButtonComponet text={"Update"} width={120} onButtonClick={() => updateCourseContent()} />
                        <TextButtonComponet text={"Close"} classStyle="btn btn-secondary" width={120} onButtonClick={() => onClose()} />
                    </Box>

                </DialogActions>
            </form>

        </>
    );
}

export default connect(
    state => ({
        loadingAction: state.common.get("loadingAction"),
    }), {
},
)(AdminCourseSectionEditForm);

